import { render, staticRenderFns } from "./TextIcon.vue?vue&type=template&id=57b017e4&scoped=true&"
var script = {}
import style0 from "./TextIcon.vue?vue&type=style&index=0&id=57b017e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b017e4",
  null
  
)

export default component.exports